<div>
  <div class="main container">
    @if (orderPageHeader.title || orderPageHeader.subtitle) {
      <div class="mb-4 py-5 has-text-centered white-background-header">
        @if (orderPageHeader.title) {
          <div class="is-size-3 has-text-weight-bold order-header-title" [innerHTML]="orderPageHeader.title"></div>
        }
        @if (orderPageHeader.subtitle) {
          <div data-qa-id="Order Header Subtitle" class="is-size-6 order-header-subtitle">
            @if (!isShippedOrder) {
              <span> Thank you for selecting a pharmacy. </span>
            }
            <span [innerHTML]="orderPageHeader.subtitle"></span>
          </div>
        }
      </div>
    }
    @if (!isLoading) {
      <div class="columns is-desktop is-reverse-desktop" data-qa-id="order columns">
        <div class="column mt-4 is-4-desktop" data-qa-id="order summary column">
          <div [class.sticky]="!isCartStatic" data-visual-test="relative" data-qa-id="Cart Upgrade Container">
            <div class="block">
              <app-order-summary></app-order-summary>
            </div>
            @if (!isFree && isOrderUpgradeEnabled) {
              <div class="block">
                <app-upgrade></app-upgrade>
              </div>
            }
            @if (!isFree && isDynamicUpgradeEnabled) {
              <div class="block">
                <app-order-upgrade-card (upgradeAvailabilityChanged)="isCartStatic = $event"></app-order-upgrade-card>
              </div>
            }
          </div>
        </div>
        <div class="column is-8-desktop" data-qa-id="order sections column">
          @if (!isShippedOrder) {
            <div class="my-4">
              <app-test-center
                [inHomeCollection]="isInHomeCollectionAllowed"
                [centerData]="reorder?.center"
                [tests]="tests"
                (inHomeCollectionStatusChange)="resetPaymentFormToPayNow()"
              ></app-test-center>
            </div>
          }
          <div class="my-4">
            <app-patient-info
              [enableGuardianForm]="shouldEnableParentConsentForm"
              [patientInfoData]="getReorderPatientInfo()"
            ></app-patient-info>
          </div>
          @if (treatmentType) {
            <div class="my-4">
              <app-order-medical-history
                [medicalHistoryData]="getReorderMedicalHistory()"
                [customMedicalHistoryQuestions]="treatmentType?.customMedicalHistoryQuestions ?? []"
              ></app-order-medical-history>
            </div>
          }
          @if (isFree || isShippedOrder) {
            <div class="my-4">
              <app-card
                [title]="addressTitle"
                headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title numbered-header"
                contentClasses="p-4"
              >
                <app-address-inputs [form]="addressForm" class="order" [multiregion]="isFree"></app-address-inputs>
                @if (isUniversityFreeOrder) {
                  <p class="mt-2 mb-4">
                    Upon a positive result, if we are unable to reach you via email, we will contact you by phone.
                  </p>
                  <app-order-phone-inputs class="order"></app-order-phone-inputs>
                }
              </app-card>
            </div>
          }
          @if (!isFree && !isBaOrder) {
            <div class="my-4">
              <app-card
                [title]="paymentCardTitle"
                headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title numbered-header"
                contentClasses="p-4 card-body-background"
              >
                <app-payment-step-tabs
                  #paymentStepTabs
                  (paymentsSelected)="onPaymentsSelected($event)"
                  (formValid)="onPaymentFormValid()"
                  [hasPartner]="hasPartner"
                  [selectedPaymentType]="selectedPaymentType"
                  [totalAmount]="getTotalAmount()"
                >
                </app-payment-step-tabs>
              </app-card>
            </div>
          }
          @if (treatmentType?.orderAgreements.requiresAcknowledgment()) {
            <div class="my-4">
              <app-order-agreements
                [orderAgreements]="treatmentType.orderAgreements"
                [parentForm]="orderForm"
              ></app-order-agreements>
            </div>
          }
          @if (isTosOnOrderPageEnabled) {
            <div class="my-4">
              <app-order-service-agreement></app-order-service-agreement>
            </div>
          }
          <div class="my-4">
            <app-payment-submit-button
              class="is-block my-4"
              [buttonText]="submitButtonText"
              [payments]="payments"
              [validationError]="formValidationError"
              [(submissionErrors)]="submissionErrors"
              [processing]="processingOrder"
              (paymentSubmitted)="onPaymentSubmit()"
            ></app-payment-submit-button>
          </div>
          <app-what-happens-next></app-what-happens-next>
        </div>
      </div>
    }
  </div>
</div>

@if (isHealthLabs) {
  <app-find-tests-modal></app-find-tests-modal>
}
